<template>
  <div class="m-contact">
    <div class="icon">
      <div
        class="icon-item"
        :class="{active:item.name===showDate.name}"
        v-for="item in List"
        :key="item.name"
        @click="select(item)"
      >
        <i class="iconfont" :class="[item.icon]"></i>
        <p>{{item.name}}</p>
      </div>
    </div>
    <div class="code">
      <img :src="showDate.code" alt>
      <h3>{{showDate.number}}</h3>
      <p>扫一扫 联系我们</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      List: [
        {
          name: "微信",
          icon: "iconweixin",
          code: require("../../assets/img/mobile/yfx.png"),
          number: "比特元客服"
        },
        {
          name: "微信公众号",
          icon: "iconweixingongzhonghao",
          code: require("../../assets/img/mobile/bty.jpg"),
          number: "比特元Bityuan"
        },
        {
          name: "QQ",
          icon: "iconqq",
          code: require("../../assets/img/mobile/QQ.png"),
          number: "238866636"
        },
        {
          name: "Twitter",
          icon: "icontuite",
          code: require("../../assets/img/mobile/Twitter.png"),
          number: "Twitter"
        },
        {
          name: "Bitcointalk",
          icon: "iconbitcointalk",
          code: require("../../assets/img/mobile/Bitciontalk.png"),
          number: "Bitcointalk"
        },
        {
          name: "电报群",
          icon: "icondianbaoqun",
          code: require("../../assets/img/mobile/telegraph.png"),
          number: "电报群"
        }
      ],
      showDate: {
        name: "微信",
        icon: "iconweixin",
        code: require("../../assets/img/mobile/yfx.png"),
        number: "比特元客服"
      }
    };
  },
  methods: {
    select(item) {
      this.showDate = item;
    }
  }
};
</script>

<style lang="scss" scoped>
.m-contact {
  padding: 0 30px;
  text-align: center;
  background: #fff;
  min-height: calc(100vh - 398px);
  .icon-item {
    margin-bottom: 30px;
    width: 100px;
    display: inline-flex;
    align-items: center;
    flex-direction: column;
    .iconfont {
      font-size: 38px;
      color: #9aaab9;
      transition: 0.3s;
    }
    p {
      margin-top: 8px;
      color: #9aaab9;
    }
  }
  .active i {
    color: #6368de !important;
    transform: scale(1.15);
  }
  .active p {
    color: #6368de !important;
  }
  .code {
    margin-top: 20px;
    img {
      height: 120px;
    }
    h3 {
      margin: 10px 0 5px;
      font-size: 17px;
      color: $black;
    }
    p {
      font-size: 14px;
      color: #9aaab9;
    }
  }
}
</style>